export const historicDates = [
  {
    title: "Наука",
    events: [
      { date: "2008",  description: "13 сентября — частное солнечное затмение, видимое в Южной Африке и части Антарктиды" },
      { date: "2016",  description: "Телескоп «Хаббл» обнаружил самую удалённую из всех обнаруженных галактик, получившую обозначение GN-z11" },
      { date: "2017",  description: "Компания Tesla официально представила первый в мире электрический грузовик Tesla Semi" },
      { date: "2018",  description: "Были обнаружены две критические уязвимости в микропроцессорах: Meltdown и Spectre" },
      { date: "2021",  description: "ОАЭ успешно вывели «Хоуп» на орбиту Красной планеты" },
      { date: "2022",  description: "Большой Адронный Коллайдер возобновляет свою работу после 3 лет модернизации" },
    ]
  },
  {
    title: "Литература",
    events: [
      { date: "2011",  description: "В Хельсинкском университете состоялась презентация романа «Теллурия» писателя Владимира Сорокина" },
      { date: "2016",  description: "В Перми вновь появилась улица Достоевского" },
      { date: "2017",  description: "В России создана новая литературная Премия «Лицей» для молодых российских писателей и поэтов" },
      { date: "2018",  description: "После смерти Андрея Битова перестала существовать Новая Пушкинская премия" },
      { date: "2020",  description: "В Индии индийским писателям и переводчикам вручили премию имени Сергея Есенина" },
      { date: "2021",  description: "На Пушкинском перевале в Армении установили памятник Александру Пушкину" },
    ]
  },
  {
    title: "Кино",
    events: [
      { date: "2014",  description: "Самый кассовый фильм 2015 года — Звёздные войны: Пробуждение силы $2 068 223 624" },
      { date: "2016",  description: "Самый кассовый фильм 2016 года — Первый мститель: Противостояние	$1 153 296 293" },
      { date: "2017",  description: "Самый кассовый фильм 2017 года — Звёздные войны: Последние джедаи $1 332 539 889" },
      { date: "2018",  description: "Самый кассовый фильм 2018 года — Мстители: Война бесконечности	$2 048 359 754" },
      { date: "2021",  description: "Самый кассовый фильм 2021 года — Человек-паук: Нет пути домой $1 909 232 550" },
      { date: "2023",  description: "Самый кассовый фильм 2023 года — Барби	$ 1 млрд 441 млн" },
    ]
  },
  {
    title: "Театр",
    events: [
      { date: "2015",  description: "Состоялась вторая интернет-трансляция «Международный день балета»" },
      { date: "2016",  description: "Мюзикл Эндрю Ллойда Уэббера «Призрак Оперы» отметил тридцатилетие со дня премьеры" },
      { date: "2017",  description: "Открылся театр «Мост», первый за 80 лет коммерческий театр в Лондоне" },
      { date: "2018",  description: "Постановка «Гарри Поттер и Проклятое дитя» получила 6 наград" },
      { date: "2021",  description: "в Люксембургском национальном театре состоялась премьера драмы Жан-Филиппа Туссена Исчезновение пейзажа" },
      { date: "2023",  description: "В Лозанне (Швейцария) в 50-й раз прошёл балетный конкурс «Приз Лозанны»" },
    ]
  },
  {
    title: "Игры",
    events: [
      { date: "2012",  description: "23—25 января	состоялось мероприятие PAX South 2015 (США Сан-Антонио)" },
      { date: "2016",  description: "14—16 марта состоялось мероприятие	Game Developers Conference 2016 (США Сан-Франциско)" },
      { date: "2017",  description: "28 сентября — 1 октября состоялось мероприятие ИгроМир 2017 (России Москва)" },
      { date: "2018",  description: "2—3 ноября — состоялось мероприятие BlizzCon 2018 (Анахайм, США)" },
      { date: "2019",  description: "Вышла Re:Zero − Starting Life in Another World: The Prophecy of the Throne	на Win, Switch, PS4" },
      { date: "2020",  description: "Вышла Pathfinder: Wrath of the Righteous DLC The Last Sarkorians	на Win, PS4, XOne" },
    ]
  },
  {
    title: "Космос",
    events: [
      { date: "1984",  description: "Первый выход женщины в открытый космос (Светлана Савицкая)." },
      { date: "1989",  description: "Первый космический корабль, пролетевший мимо Нептуна." },
      { date: "1992",  description: "Первый космический аппарат, нанесший на карту Венеру полностью." },
      { date: "2004",  description: "Первый возврат образца за пределы лунной орбиты (солнечный ветер)." },
      { date: "2010",  description: "Первый космический корабль, вышедший на орбиту Луны в точке Лагранжа 1." },
      { date: "2023",  description: "Первая посадка на южный полюс Луны." },
    ]
  },
]